import { render, staticRenderFns } from "./MotorsportEventCard.vue?vue&type=template&id=1bb74227&scoped=true"
import script from "./MotorsportEventCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./MotorsportEventCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MotorsportEventCard.vue?vue&type=style&index=0&id=1bb74227&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb74227",
  null
  
)

export default component.exports